
export const OEAnalyticsEventDataFlag = {
    none:                                   0,
    target:                                 1,
    version:                                2,
    def:                                    3,
    all:                                    3
};

export const OEAnalyticsEventName = {
    helpViewEntryClick:                     'Help-View click',
    // events implemented in core, we also define them here for the sake of completeness
    appOpened:                              'App opened',
    targetChanged:                          'Target changed',
    targetLoaded:                           'Target loaded',
    presentationInMediaCenter:              'Presentation in media center',
};

export const OEAnalyticsEventDataParamName = {
    target:                                 'target',
    version:                                'version',
    id:                                     'id',
    desc:                                   'desc',
};
